"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmallHeader = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _userProfile = require("user-profile");

var _LoginForm = require("components/LoginForm");

var _eventDispatcher = babelHelpers.interopRequireDefault(require("event-dispatcher"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp, _class3, _descriptor7, _temp2;

var SmallBannerBlock = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(SmallBannerBlock, _Block);

  function SmallBannerBlock() {
    var _babelHelpers$getProt2;

    var _this3;

    babelHelpers.classCallCheck(this, SmallBannerBlock);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(SmallBannerBlock)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "header", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    return _this3;
  }

  babelHelpers.createClass(SmallBannerBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement(SmallHeader, this.header);
    }
  }]);
  return SmallBannerBlock;
}(_base.default), _temp2), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "header", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = SmallBannerBlock;
var SmallHeader = (_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(SmallHeader, _React$Component);

  function SmallHeader() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SmallHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SmallHeader)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "name", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "buttonTitle", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "isLoginButton", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "linkUrl", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "openInNewWindow", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.backgroundStyleValue = _base.default.styleForBackgroundObject(_this.background);
    _this.state = {
      userProfile: _this.isLoginButton ? (0, _userProfile.getUserProfileNow)() : null
    };
    return _this;
  }

  babelHelpers.createClass(SmallHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.isLoginButton && !this.state.userProfile) (0, _userProfile.getUserProfile)().then(function (userProfile) {
        return _this2.setState({
          userProfile: userProfile
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps) {
      if (newProps.background != this.background) this.backgroundStyleValue = _base.default.styleForBackgroundObject(this.background);
    }
  }, {
    key: "showLoginForm",
    value: function showLoginForm(event) {
      (0, _LoginForm.show)('sign-in').then(function (state) {
        if (state) {
          var modal = state.modal,
              useCustomHome = state.useCustomHome,
              defaultHome = state.defaultHome;
          if (modal) modal.hide();

          if (useCustomHome && location.href.split('?').shift() == defaultHome) {
            if (history.pushState) {
              history.pushState({}, "", useCustomHome);
            }
          }
        }

        (0, _userProfile.userProfileUpdated)(state && state.loggedOut === true).then(function (profile) {
          if (state) {
            (0, _eventDispatcher.default)(state.isNewAccount ? 'account-created' : 'signed-in', profile);
          }
        });
      });
      event.preventDefault();
    }
  }, {
    key: "showButton",
    value: function showButton() {
      var showButton = !!this.linkUrl;
      var linkData = {
        href: this.linkUrl,
        className: 'btn-secondary'
      };

      if (this.openInNewWindow) {
        linkData.target = '_blank';
      }

      if (this.isLoginButton) {
        if (this.userProfile.guest) {
          showButton = true;
          linkData.onClick = this.showLoginForm;
          linkData.href = "javascript:void(0)";
          delete linkData.target;
        } else {
          showButton = false;
        }
      }

      if (showButton) return _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("a", linkData, this.buttonTitle));
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "inner-content"
      }, _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("h1", null, this.name), this.summary && _react.default.createElement("h2", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, this.summary)), this.showButton());
    }
  }]);
  return SmallHeader;
}(_react.default.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "buttonTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "isLoginButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linkUrl", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "openInNewWindow", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showLoginForm", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showLoginForm"), _class.prototype)), _class);
exports.SmallHeader = SmallHeader;